import { TemplateHelper, ConfigHelper, LocalizationHelper } from "../../helpers"
import { Activity, Enums } from "../../models/common"

import { USER_SESSION_SERVICE_NAME, UserSessionService } from "../user-session"
import { SYSTEM_CONTEXT_LIST_SERVICE_NAME, SystemContextListService } from "../system"

//#region Public Types

export const METER_CONTEXT_MENU_SERVICE_NAME = 'meterContextMenuService'
export const METER_CONTEXT_MENU_SERVICE_PROVIDER_NAME = 'meterContextMenuServiceProvider'

export type IdMeterGridContextMenuOptions = {
    idReferenceTypes?: number[]
    onEdit?: (args: any) => void
    getCorrespondingActionType?: (idReferenceType: Enums.ReferenceType, args: any) => void
}

//#endregion

export class MeterContextMenuService {

    // #region Ctor

    public constructor(
        private readonly systemContextListService: SystemContextListService,
        private readonly userSessionService: UserSessionService
    ) { }

    // #endregion


    // #region Public Methods

    public getContextMenuItems(options: IdMeterGridContextMenuOptions): any[] {
        const items: { beginGroup?: boolean, template: string, onItemClick: (args: any) => void }[] = []

        if (options == null) {
            return items
        }

        if (options.onEdit && this.userSessionService.getLoggedOperator().hasPermission(Activity.METER_EDIT)) {
            items.push({
                beginGroup: true,
                template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Edit), ConfigHelper.Icon.EDIT, this.userSessionService),

                onItemClick: (args: any) => {
                    options.onEdit(args)
                },
            })
        }

        if (options.idReferenceTypes != null) {

            if (this.userSessionService.getLoggedOperator().hasPermission(Activity.LOCATION_LIST)
                && !this.userSessionService.getLoggedOperator().hasPermission(Activity.LOCATION_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationModule)
            ) {
                items.push({
                    beginGroup: true,
                    template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowLocations), ConfigHelper.Icon.LOCATIONS, this.userSessionService),

                    onItemClick: () => {
                        this.systemContextListService.getContextList(Enums.ReferenceType.IdLocation, options.idReferenceTypes, Enums.ReferenceType.IdMeter)
                    }
                })
            }

            if (this.userSessionService.getLoggedOperator().hasPermission(Activity.DEVICE_LIST)
                && !this.userSessionService.getLoggedOperator().hasPermission(Activity.DEVICE_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.DeviceModule)) {
                items.push({
                    template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowDevices), ConfigHelper.Icon.DEVICES, this.userSessionService),

                    onItemClick: () => {
                        this.systemContextListService.getContextList(Enums.ReferenceType.SerialNbr, options.idReferenceTypes, Enums.ReferenceType.IdMeter)
                    }
                })
            }


            if (this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_LIST)
                && !this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TaskModule)) {
                items.push({
                    template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowTasks), ConfigHelper.Icon.TASKS, this.userSessionService),

                    onItemClick: () => {
                        this.systemContextListService.getContextList(Enums.ReferenceType.IdTask, options.idReferenceTypes, Enums.ReferenceType.IdMeter)
                    }
                })
            }

            if (this.userSessionService.getLoggedOperator().hasPermission(Activity.ISSUE_LIST)
                && !this.userSessionService.getLoggedOperator().hasPermission(Activity.ISSUE_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.IssueMoodule)) {
                items.push({
                    template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowIssues), ConfigHelper.Icon.ISSUES, this.userSessionService),

                    onItemClick: () => {
                        this.systemContextListService.getContextList(Enums.ReferenceType.IdIssue, options.idReferenceTypes, Enums.ReferenceType.IdMeter)
                    }
                })
            }

            if (this.userSessionService.getLoggedOperator().hasPermission(Activity.SIM_CARD_LIST)
                && !this.userSessionService.getLoggedOperator().hasPermission(Activity.SIM_CARD_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.SimCardModule)) {
                items.push({
                    template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowSimCards), ConfigHelper.Icon.SIM_CARD, this.userSessionService),

                    onItemClick: () => {
                        this.systemContextListService.getContextList(Enums.ReferenceType.IdSimCard, options.idReferenceTypes, Enums.ReferenceType.IdMeter)
                    }
                })
            }

            if (this.userSessionService.getLoggedOperator().hasPermission(Activity.ACTION_LIST)
                && !this.userSessionService.getLoggedOperator().hasPermission(Activity.ACTION_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.ActionModule)) {
                items.push({
                    template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowRecentActions), ConfigHelper.Icon.RECENT_ACTIONS, this.userSessionService),

                    onItemClick: () => {
                        this.systemContextListService.getContextList(Enums.ReferenceType.IdAction, options.idReferenceTypes, Enums.ReferenceType.IdMeter)
                    }
                })
            }

            if (this.userSessionService.getLoggedOperator().hasPermission(Activity.CASHIER_PANEL_VIEW)) {
                items.push({
                    template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowCashierPanel), ConfigHelper.Icon.DOLLAR, this.userSessionService),

                    onItemClick: () => {
                        this.systemContextListService.getContextList(Enums.ReferenceType.IdPaymentModule, options.idReferenceTypes, Enums.ReferenceType.IdMeter)
                    }
                })
            }

            if (this.userSessionService.getLoggedOperator().hasPermission(Activity.CONSUMER_LIST)) {
                items.push({
                    template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowConsumers), ConfigHelper.Icon.CONTACT_MAIL, this.userSessionService),

                    onItemClick: () => {
                        this.systemContextListService.getContextList(Enums.ReferenceType.IdConsumer, options.idReferenceTypes, Enums.ReferenceType.IdMeter)
                    }
                })
            }

            if (this.userSessionService.getLoggedOperator().hasPermission(Activity.TARIFF_LIST)) {
                items.push({
                    template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowTariffs), ConfigHelper.Icon.TARIFF, this.userSessionService),

                    onItemClick: () => {
                        this.systemContextListService.getContextList(Enums.ReferenceType.IdTariff, options.idReferenceTypes, Enums.ReferenceType.IdMeter)
                    }
                })
            }
        }

        if (options.getCorrespondingActionType != null && this.userSessionService.getLoggedOperator().hasPermission(Activity.ACTION_RUN, Enums.ReferenceType.IdMeter)) {
            items.push({
                beginGroup: true,
                template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.RunActions), ConfigHelper.Icon.RUN_ACTIONS, this.userSessionService),

                onItemClick: (args: any) => {
                    options.getCorrespondingActionType(Enums.ReferenceType.IdMeter, args)
                },
            })
        }

        return items
    }

    // #endregion
}

export class MeterContextMenuServiceProvider
    implements ng.IServiceProvider {

    //#region IServiceProvider Implementation 

    public $get = [SYSTEM_CONTEXT_LIST_SERVICE_NAME, USER_SESSION_SERVICE_NAME, function (systemContextListService: SystemContextListService, userSessionService: UserSessionService) {
        return new MeterContextMenuService(systemContextListService, userSessionService)
    }]

    //#endregion
} 
